var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"row",attrs:{"no-body":""}},[_c('div',{staticClass:"p-5"},[_vm._v(" "+_vm._s(_vm.motivation ? _vm.motivation : "(Geen motivatie ingevuld)")+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }